interface MetricItem {
  label: string
  value: string
  context?: string
  active?: boolean
  onClick?: () => void
}

export function MetricStrip({ items }: { items: MetricItem[] }) {
  return (
    <div className="metric-strip">
      {items.map((item) => {
        const content = <>
          <span className="metric-label">{item.label}</span>
          <strong className="metric-value">{item.value}</strong>
          {item.context && <span className="metric-context">{item.context}</span>}
        </>
        return item.onClick ? (
          <button
            type="button"
            className={`metric-item is-interactive ${item.active ? 'is-active' : ''}`.trim()}
            key={item.label}
            aria-pressed={item.active}
            onClick={item.onClick}
          >
            {content}
          </button>
        ) : (
          <div className="metric-item" key={item.label}>{content}</div>
        )
      })}
    </div>
  )
}
